import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=a2e96bc4&scoped=true&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=a2e96bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e96bc4",
  null
  
)

export default component.exports